import { useNoddiQueryParam } from 'noddi-ui-web';
import { DateParam } from 'use-query-params';

/** The month picked in the service partner table; unset shows the page period. */
export const usePartnerMonthParam = () => useNoddiQueryParam('partner-month', DateParam);
